export default __webpack_public_path__ + "static/media/bg6.8488e194.jpg";